"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IChatSessionStatus = exports.SocketEvent = exports.IStatus = exports.IMessageStatus = exports.IMessageDirection = exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType["GREETING"] = "GREETING";
    MessageType["TEXT"] = "TEXT";
    MessageType["SYSTEM_MESSAGE"] = "SYSTEM_MESSAGE";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
var IMessageDirection;
(function (IMessageDirection) {
    IMessageDirection["OUTBOUND"] = "OUTBOUND";
    IMessageDirection["INBOUND"] = "INBOUND";
})(IMessageDirection = exports.IMessageDirection || (exports.IMessageDirection = {}));
var IMessageStatus;
(function (IMessageStatus) {
    IMessageStatus["SENT"] = "SENT";
    IMessageStatus["DELIVERED"] = "DELIVERED";
    IMessageStatus["FAILED"] = "FAILED";
})(IMessageStatus = exports.IMessageStatus || (exports.IMessageStatus = {}));
var IStatus;
(function (IStatus) {
    IStatus["IDLE"] = "IDLE";
    IStatus["TYPING"] = "TYPING";
})(IStatus = exports.IStatus || (exports.IStatus = {}));
var SocketEvent;
(function (SocketEvent) {
    SocketEvent["CHAT_USER_RECONNECT"] = "chat:user:reconnect";
    SocketEvent["CHAT_AGENT_DISCONNECTED"] = "chat:agent:disconnected";
    SocketEvent["CHAT_SESSION_START"] = "chat:session:start";
    SocketEvent["CHAT_SESSION_HISTORY"] = "chat:session:history";
    SocketEvent["CHAT_SESSION_ENDED"] = "chat:session:ended";
    SocketEvent["CHAT_SESSION_TIMED_OUT"] = "chat:session:timed_out";
    SocketEvent["CHAT_SESSION_TIMEOUT_WARNING"] = "chat:session:timeout:warning";
    SocketEvent["CHAT_IN_MESSAGE"] = "chat:in:message";
    SocketEvent["CHAT_OUT_MESSAGE"] = "chat:out:message";
    SocketEvent["CHAT_AGENT_JOINED"] = "chat:agent:joined";
    SocketEvent["CHAT_USER_STATUS"] = "chat:user:status";
    SocketEvent["CHAT_AGENT_STATUS"] = "chat:agent:status";
})(SocketEvent = exports.SocketEvent || (exports.SocketEvent = {}));
var IChatSessionStatus;
(function (IChatSessionStatus) {
    IChatSessionStatus["PENDING"] = "PENDING";
    IChatSessionStatus["ACTIVE"] = "ACTIVE";
    IChatSessionStatus["TIMED_OUT"] = "TIMED_OUT";
    IChatSessionStatus["ENDED"] = "ENDED";
})(IChatSessionStatus = exports.IChatSessionStatus || (exports.IChatSessionStatus = {}));
